module.exports = __webpack_public_path__ + "img/edit.bab36387.svg";